import { z } from 'zod';

export const couponDepositSchema = z.object({
  account_id: z.string().min(1, 'Please select an account'),
  amount: z.number().positive('Amount must be greater than zero'),
  transaction_date: z.string().refine(val => !isNaN(Date.parse(val)), 'Invalid date'),
});

export type CouponDepositFormValues = z.infer<typeof couponDepositSchema>;
